import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { PuiDialog, type PuiDialogProps, Text } from '@pbt/pbt-ui-components'

import i18n from '~/locales/i18n'
import { getImgSrcSetAttributes } from '~/utils/images'

import ListPreview1x from './images/notificationStyleListPreview@1x.png'
import ListPreview2x from './images/notificationStyleListPreview@2x.png'
import MenuPreview1x from './images/notificationStyleMenuPreview@1x.png'
import MenuPreview2x from './images/notificationStyleMenuPreview@2x.png'
import PopUpPreview1x from './images/notificationStylePopUpPreview@1x.png'
import PopUpPreview2x from './images/notificationStylePopUpPreview@2x.png'

const useStyles = makeStyles(
  () => ({
    paper: {
      width: 1020,
      maxWidth: 1020,
    },
    img: {
      width: 313,
    },
    dialogTitle: {
      borderBottom: 'none',
    },
  }),
  { name: 'NotificationStylesPreviewDialog' },
)

const stylesPreview = [
  {
    title: i18n.t('Common:POP_UPS'),
    imgSrcProps: getImgSrcSetAttributes({
      x1: PopUpPreview1x,
      x2: PopUpPreview2x,
    }),
  },
  {
    title: i18n.t('Common:MENU'),
    imgSrcProps: getImgSrcSetAttributes({
      x1: MenuPreview1x,
      x2: MenuPreview2x,
    }),
  },
  {
    title: i18n.t('Common:LIST'),
    imgSrcProps: getImgSrcSetAttributes({
      x1: ListPreview1x,
      x2: ListPreview2x,
    }),
  },
]

export interface NotificationStylesPreviewDialogProps extends PuiDialogProps {}

const NotificationStylesPreviewDialog = ({
  open,
  onClose,
}: NotificationStylesPreviewDialogProps) => {
  const classes = useStyles()
  const { t } = useTranslation('Notifications')

  return (
    <PuiDialog
      aria-labelledby="notification-styles-preview-dialog"
      classes={{
        paper: classes.paper,
        dialogTitle: classes.dialogTitle,
      }}
      open={open}
      title={t(
        'Notifications:NOTIFICATION_SETTINGS_COMBINATION_TABLE.NOTIFICATION_STYLES',
      )}
      onClose={onClose}
    >
      <Grid container columnSpacing={2} pb={17} pt={6} px={2} wrap="nowrap">
        {stylesPreview.map((stylePreview) => (
          <Grid container item direction="column" key={stylePreview.title}>
            <Text strong mb={2} ml={1} variant="body2">
              {stylePreview.title}
            </Text>
            <img
              alt={stylePreview.title}
              className={classes.img}
              {...stylePreview.imgSrcProps}
            />
          </Grid>
        ))}
      </Grid>
    </PuiDialog>
  )
}

export default NotificationStylesPreviewDialog
